// extracted by mini-css-extract-plugin
module.exports = {"history":"History_history__2AFTJ","historyList":"History_historyList__1RHSK","historyItem":"History_historyItem__28iDm","query":"History_query__11u3a"};